import Vue from "vue";
import { mapState } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import logEntidadeComponent from "@/components/child/logEntidade/logEntidade.vue";
import CapaSeiComponent from "@/components/parent/crud/veterinario/capaSei/capaSei";
import capaSeiComponent from "@/components/parent/crud/veterinario/capaSei/capaSei.vue";
import { Component, Watch } from "@/decorators";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import MesesDoAno from "@/models/enum/mesesDoAno";
import UsuarioModel from "@/models/usuarioModel";
import PDFService from "@/services/pdf/PDFService";
import { AppState } from "@/store/store";

import "../crud.scss";

@Component({
    components: {
        fieldsetComponent,
        actionBarComponent,
        comboComponent,
        capaSeiComponent,
        checkboxComponent,
        logEntidadeComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
    },
})
export default class ManipuladoresComponent extends Vue {
    private service = new PDFService("ManipuladoresPDF");
    private capaSeiComponent: CapaSeiComponent;
    usuarioLogado: UsuarioModel;

    tipoPeriodoId: number = null;
    responsavelId: number = null;
    tipoControleId = 1;
    periodoId: number = null;
    ano: number = null;
    mes: number = null;
    primeiraGeracao = false;
    gerarInventario = false;

    get isMapaExcel() {
        return this.tipoControleId === 4;
    }

    tipoPeriodoOptions: Array<Object> = [
        { text: "Semestral", value: 1 },
        { text: "Trimestral", value: 2 },
        { text: "Mensal", value: 3 },
        { text: "Anual", value: 5 },
    ];

    responsavelOptions: Array<Object> = [
        { text: "Farmacêutico", value: 1 },
        { text: "Veterinário MAPA", value: 2 },
    ];

    tipoControleOptions: Array<object> = [
        { text: "ANVISA", value: 1 },
        { text: "MAPA", value: 2 },
        { text: "Mapa Excel", value: 4 },
    ];

    semestralOptins: Array<object> = [
        { text: "1º Semestre", value: 6 },
        { text: "2º Semestre", value: 7 },
    ];

    trimestralOptins: Array<object> = [
        { text: "1º Trimestre", value: 1 },
        { text: "2º Trimestre", value: 2 },
        { text: "3º Trimestre", value: 3 },
        { text: "4º Trimestre", value: 4 },
    ];

    mesesOptions = EnumExtensions.getNamesAndValuesOrderedByValues(MesesDoAno);

    private load() {
        this.ano = new Date().getFullYear();
    }

    private async save() {
        try {
            if (this.tipoPeriodoId === 3) {
                this.$validator.detach("periodoId");
                this.$validator.detach("mes");
                this.$validator.attach({
                    name: "mes",
                    rules: !this.mes || this.mes == 0 ? "required|maior_que_zero" : "",
                });
            } else {
                this.$validator.detach("mes");
                this.$validator.detach("periodoId");
                this.$validator.attach({
                    name: "periodoId",
                    rules: !this.periodoId ? "required" : "",
                });
            }

            const isValid = await this.$validator.validateAll();

            if (isValid) {
                if (this.isMapaExcel) {
                    const filters = {
                        periodo: this.periodoId,
                        responsavel: this.responsavelId,
                        tipoControle: this.tipoControleId,
                        ano: this.ano,
                        mes: this.mes,
                        gerarInventario: this.gerarInventario,
                    };

                    await this.service.geraXLSWithFilters(filters).withLoading();
                } else {
                    const filters = {
                        periodo: this.periodoId,
                        responsavel: this.responsavelId,
                        tipoControle: this.tipoControleId,
                        ano: this.ano,
                        mes: this.mes,
                        capaSei: this.capaSeiComponent.model,
                        primeiraGeracao: this.primeiraGeracao,
                    };

                    await this.service.geraPDFWithFilters(filters).withLoading();

                    if (this.capaSeiComponent.foiAlterado()) {
                        this.capaSeiComponent.insertUpdate();
                    }
                }

                this.$showSuccess("Sucesso", "Arquivo foi gerado corretamente.");
            }
        } catch (e) {
            this.$showError("Erro", `Erro ao gerar o arquivo.\n Erro: ${e.message}`);
        }
    }

    private cancel() {
        this.$router.back();
    }

    @Watch("tipoPeriodoId")
    private onChangeTipoPeriodoId() {
        if (this.tipoPeriodoId == 5) {
            this.periodoId = 5;
        }
        this.mes = 0;
    }

    private async mounted() {
        this.capaSeiComponent = this.$refs.capaSeiComponent as CapaSeiComponent;
        this.load();
    }
}
